import Utils from './utils';
import Feature from './feature';
import UiInteraction from './ui_interaction';

const Search = {
	get input() {
		return document.getElementById('search_input');
	},

	get submitButton() {
		return document.querySelector('.uw-search-submit');
	},

	debouncedSearch: Utils.debounce(() => {
		Search.search(Search.input.value);
	}, 200),

	search: function (term) {
		let url = W.api_root + 'search.html?';
		const params = { s: term };
		const urlSearchParams = new URLSearchParams(params);
		const resultsContainer = document.querySelector('.uw-search-results');
		const mapMenu = document.querySelector('.map-menu');
		const loadingIndicator = mapMenu.querySelector('.loading');

		loadingIndicator.classList.add('show');

		if (typeof gtag !== 'undefined') {
			gtag('event', 'search', { event_category: 'Search', event_label: term });
		}

		url = url + urlSearchParams;

		fetch(url)
			.then((response) => {
				if (!response.ok) {
					throw new Error(`HTTP error! Status: ${response.status}`);
				}
				return response.text();
			})
			.then((response) => {
				loadingIndicator.classList.remove('show');

				response = response.replace(/<!--[\s\S]*?-->/g, '');

				mapMenu.classList.add('is-searching');
				resultsContainer.classList.add('show');
				if ('' === response) {
					if (Search.input.value !== '') {
						response = '<ul><li class="no-results">No results found</li></ul>';
					} else {
						mapMenu.classList.remove('is-searching');
						resultsContainer.classList.remove('show');
					}
				}
				resultsContainer.innerHTML = response.replace(/<!--[\s\S]*?-->/g, '');

				const listItems = document.querySelectorAll('.uw-search-results-item button');

				listItems.forEach((item) => {
					item.addEventListener('click', (e) => {
						e.preventDefault();
						resultsContainer.classList.remove('show');
						mapMenu.classList.remove('is-searching');

						const button = e.target;
						const feature = Feature.fromSearch({
							searchable_id: button.dataset.mapObjectId,
							searchable_type: button.dataset.model,
						});

						if (feature) {
							// remove any open popups
							UiInteraction.clearAllPopups();
							UiInteraction.fetchAndAddFeature(feature, { origin: 'search' });
						}
						// If we hit a tag, trigger the checkbox in the dom
						else if (button.dataset.model === 'Tag') {
							console.log('TAGS');
							// Check the check-box for the layer and trigger change()
							// By triggering change, the layer will be enabled if it isn't already
							document.getElementById('tag-layer-' + button.dataset.mapObjectId).click();
						}
					});
				});

				let activeIndex = -1;
				document.addEventListener('keydown', (e) => {
					if (e.key === 'ArrowUp' && activeIndex > 0) {
						e.preventDefault();
						activeIndex--;
						listItems[activeIndex].focus();
					} else if (e.key === 'ArrowUp' && activeIndex === 0) {
						e.preventDefault();
						Search.input.focus();
						Search.input.setSelectionRange(Search.input.value.length, Search.input.value.length);
					} else if (e.key === 'ArrowDown' && activeIndex < listItems.length - 1) {
						e.preventDefault();
						activeIndex++;
						listItems[activeIndex].focus();
					}
				});
			});
	},

	addListeners: () => {
		if (!Search.input) return;
		Search.input.addEventListener('input', Search.debouncedSearch);

		Search.input.addEventListener('focus', (e) => {
			const searchTerm = e.target.value;
			const resultsContainer = document.querySelector('.uw-search-results');

			// if search results container is not visible but there is a search
			// term in the input, run search again
			if (
				resultsContainer.offsetWidth === 0 &&
				resultsContainer.offsetHeight === 0 &&
				!/^\s*$/.test(searchTerm)
			) {
				Search.search(searchTerm);
			}
		});

		// unlikely a user clicks this, but run the search again
		// Search.submitButton.addEventListener('click', (e) => {
		// 	e.preventDefault();
		// 	Search.search(Search.input.value);
		// });
	},
};

Search.addListeners();

export default Search;
